import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/RIU_Hotel.webp';

const Project_one = () => {

  return (
     <>
    
          <div className='project_1_work' id="workBanner">
    
            <div className="container project_our_work">
    
              <div className="heading">
                <h1>RIU Hotel</h1>
              </div>
    
              <hr></hr>
              <div className='project_section'>
                <div className="project_section_content">
                  <h1 className="project_scope">Scope of Work</h1>
                  <p>A beachfront hotel property operated by RIU Hotels & Resorts — one of the world's top 20 hotel chains by room count. The
                    project involved significant underground district cooling infrastructure and hotel CHW distribution works.</p>
                  <p>MAIN CONTRACTOR : Binladin</p>
                  <p>MEP CONTRACTOR : -</p>
                  <p>GEMCO SCOPE OF WORKS : Underground CHW pipework and hotel CHW distribution works</p>
                  {/* <h2 className="project_years">2014 – 2022</h2> */}
                </div>
                <div className='project_1_card'>
                  <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                </div>
              </div>
            </div>
          </div>
    
        </>

  )
}

export default Project_one